// Auth0 configuration for SPA
export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  },
  cacheLocation: 'localstorage',
  useRefreshTokens: true,
};

// Validate required environment variables
export const validateAuth0Config = () => {
  const requiredVars = ['REACT_APP_AUTH0_DOMAIN', 'REACT_APP_AUTH0_CLIENT_ID'];
  const missingVars = requiredVars.filter(varName => !process.env[varName]);
  
  if (missingVars.length > 0) {
    throw new Error(
      `Missing required Auth0 environment variables: ${missingVars.join(', ')}`
    );
  }
  
  return true;
};
